import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';

import { Principal } from './principal.service';
// import { LoginModalService } from '../login/login-modal.service';
import { StateStorageService } from './state-storage.service';
import { NGXLogger } from 'ngx-logger';
import { DataStorageService } from '../data-storage.service';
import { InfoService } from '../../info/info-service';

@Injectable()
export class UserRouteAccessService implements CanActivate {

    constructor(private router: Router,
        private principal: Principal,
        private stateStorageService: StateStorageService,
        private dataStorageService: DataStorageService,
        private logger: NGXLogger,
        private infoService: InfoService) {
    }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Promise<boolean> {

        const authorities = route.data['authorities'];
        if (!authorities || authorities.length === 0) {
            return true;
        }

        return this.checkLogin(authorities, state.url);
    }

    checkLogin(authorities: string[], url: string): Promise<boolean> {
        this.logger.debug('checkLogin called... ');
        this.logger.debug('authorities... ' + authorities);
        this.logger.debug('url... ' + url);
        const principal = this.principal;
        return Promise.resolve(
            principal.identity()
                .then((account) => {
                    this.logger.debug('account... ' + account);
                    //this.logger.debug('principal.hasAnyAuthorityDirect(authorities)... '+principal.hasAnyAuthorityDirect(authorities));
                    if (account && principal.hasAnyAuthorityDirect(authorities)) {
                        return true;
                    }
                    this.stateStorageService.storeUrl(url);
                    this.infoService.header = "Oops!";
                    this.infoService.message = "Access Denied";
                    this.dataStorageService.setUserData(null);
                    this.router.navigate(['info'])
                        .then(() => {
                            // only show the login dialog, if the user hasn't logged in yet
                            if (!account) {
                                // this.loginModalService.open();
                                this.logger.debug('user not logged in... ');
                            }
                        });
                    return false;
                }).catch(this.handleError))
            .catch(this.handleError);
    }
    handleError(error: any): Promise<any> {
        this.logger.debug('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// ./src/app/shared/auth/user-route-access-service.ts